// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21mUT","inner":"Footer_inner__maOx-"};